import { createSlice } from '@reduxjs/toolkit'

const initialState = {}

const chapterSlice = createSlice({
    name: 'chapter',
    initialState,
    // reducers: {},
})

export default chapterSlice.reducer
